import { WalletTransactionPage } from '../../components/WalletTransactionPage';

export default function DepositPage() {
  return <WalletTransactionPage mode="deposit" />;
}
